import { render, staticRenderFns } from "./BLOnBoardDatePop.vue?vue&type=template&id=43acf598&scoped=true"
import script from "./BLOnBoardDatePop.vue?vue&type=script&lang=js"
export * from "./BLOnBoardDatePop.vue?vue&type=script&lang=js"
import style0 from "./BLOnBoardDatePop.vue?vue&type=style&index=0&id=43acf598&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43acf598",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43acf598')) {
      api.createRecord('43acf598', component.options)
    } else {
      api.reload('43acf598', component.options)
    }
    module.hot.accept("./BLOnBoardDatePop.vue?vue&type=template&id=43acf598&scoped=true", function () {
      api.rerender('43acf598', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/BLOnBoardDatePop.vue"
export default component.exports